export const config = {
  title: "Heroes Auto Detailing | Professional Auto Detailing & Ceramic Coating in Rossville, GA",
  meta: {
    description:
      "Heroes Auto Detailing provides premium auto detailing, ceramic coating, paint correction, and comprehensive vehicle care services in Rossville, GA. Professional results with advanced techniques and premium products.",
    keywords: [
      "Heroes Auto Detailing",
      "Auto Detailing Rossville GA",
      "Ceramic Coating Georgia",
      "Paint Correction Rossville",
      "Car Detailing Services GA",
      "Vehicle Detailing Rossville",
      "Automotive Detailing Georgia",
      "Professional Car Care"
    ],
    author: "Heroes Auto Detailing",
    canonicalUrl: "https://www.heroesautodetailing.com/",
  },
  sections: {
    header: {
      businessName: "Heroes Auto Detailing",
    },
    sectionB: {
      heroTitle: "Premium Auto Detailing & Ceramic Coating Excellence",
      heroSubtitle: "Professional Vehicle Care Services in Rossville, GA",
      learnAboutText: "Get Your Free Quote",
      phoneNumber: "4237100773",
      phoneLabel: "(423) 710-0773",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2170837839/photo/professional-car-detailing-with-an-auto-polisher-in-a-garage-setting.jpg?s=612x612&w=0&k=20&c=W06duJxulHcUgMIymfrQJrb5Oan6aQI2eP3FofFIFb4=",
      cardData: [
        {
          title: "Ceramic Coating",
          description:
            "Professional ceramic coating services providing years of protection with advanced techniques, premium products, and flawless results.",
        },
        {
          title: "Paint Correction",
          description:
            "Expert paint correction services to restore your vehicle's finish, removing swirl marks, scratches, and imperfections.",
        },
        {
          title: "Full Detailing",
          description:
            "Comprehensive interior and exterior detailing services combining deep cleaning, protection, and enhancement for showroom results.",
        },
      ],
      description:
        "Heroes Auto Detailing is your premier destination for professional auto detailing, ceramic coating, and paint correction services in Rossville, Georgia, delivering exceptional results that exceed expectations.",
    },
    sectionC: {
      servicesTitle: "Professional Auto Detailing Services",
      servicesDescription:
        "From deep paint correction and ceramic coatings to comprehensive detailing packages, we combine premium products, advanced techniques, and years of experience to deliver flawless results every time.",
      cards: [
        {
          title: "Ceramic Coating Services",
          description:
            "Advanced ceramic coating applications providing long-lasting protection, enhanced gloss, and superior durability for your vehicle's paint and surfaces.",
          imageSrc: "https://media.istockphoto.com/id/2210225131/photo/car-detailing-nano-coating-on-a-car.jpg?s=612x612&w=0&k=20&c=aYCVw3ONBTsbX5jnfPVanAoHjlcR5nXu2X5qyB6TBkA=",
          imageAlt: "Ceramic Coating Application",
        },
        {
          title: "Paint Correction & Restoration",
          description:
            "Professional paint correction services to remove swirl marks, scratches, and oxidation, restoring your vehicle's paint to like-new condition.",
          imageSrc: "https://media.istockphoto.com/id/2199814452/photo/car-wash-or-detailing-studio-employee-applies-ceramic-or-graphene-coating.jpg?s=612x612&w=0&k=20&c=rGKX6ou2aI0XtmKZd7dQ6hSnpQbxcCM3dtZQCCKS5cs=",
          imageAlt: "Paint Correction Services",
        },
        {
          title: "Complete Detailing Packages",
          description:
            "Comprehensive interior and exterior detailing services including deep cleaning, protection, and enhancement for luxury cars, trucks, and daily drivers.",
          imageSrc: "https://media.istockphoto.com/id/1273682054/photo/car-service-worker-applying-nano-coating-on-a-car-detail.jpg?s=612x612&w=0&k=20&c=w2YoGPnv24lcITfiH7jnTYLAj9xCXUrlbHn33lxcd2U=",
          imageAlt: "Complete Auto Detailing",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Window Tinting Services",
        "Mold Remediation & Cleanup",
        "Interior Deep Cleaning",
        "Headlight Restoration",
        "Engine Bay Detailing",
      ],
    },
    sectionD: {
      aboutTitle: "About Heroes Auto Detailing",
      aboutImage: {
        src: "https://media.istockphoto.com/id/1194687583/photo/worker-examining-vehicle-body-for-scratches.jpg?s=612x612&w=0&k=20&c=tYB4Bgir9Y4eO2x6XazRXnrSnBHZB7t0BOU0j2tYPZ8=",
        alt: "Heroes Auto Detailing Professional Team",
      },
      aboutText: [
        "Heroes Auto Detailing is a premier automotive detailing service located in Rossville, Georgia, specializing in ceramic coatings, paint correction, and comprehensive vehicle care. We combine premium products with advanced techniques to deliver exceptional results that exceed our customers' expectations.",
        "Whether you drive a luxury vehicle, truck, or daily commuter, Heroes has a detailing package designed to meet your specific needs. Our experienced team is committed to protecting your investment while enhancing your vehicle's appearance with meticulous attention to detail and professional-grade treatments.",
      ],
    },
    sectionE: {
      profileImage: null, // URL or null
      profileAlt: "Heroes Auto Detailing",
      businessName: "Heroes Auto Detailing",
      contact: {
        phone: "4237100773",
        phoneLabel: "(423) 710-0773",
        email: "michaelarp75@gmail.com",
        website: "https://www.heroesautodetailing.com/",
        address: "32 Allie Lane, Rossville, GA 30741",
      },
      socialMedia: {
        bizSolutionsUrl: "https://mybizsolutions.us/biz/heroes-auto-detailing",
        googlePlus: "",
        linkedIn: "",
        facebook: "",
        twitter: "",
        tiktok: "",
        instagram: "",
        youtube: "",
        // "" if empty. 
      },
    },
    sectionF: {
      address: "32 Allie Lane, Rossville, GA 30741",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3262.123456789!2d-85.2866778!3d34.9728567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x885f1234567890a%3A0x1234567890abcdef!2s32%20Allie%20Ln%2C%20Rossville%2C%20GA%2030741!5e0!3m2!1sen!2sus!4v1698765432100!5m2!1sen!2sus",
    },
  },
};

export default config;